import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from './role.guard';
import { StatusComponent } from './status/status.component';
import { ProfileConst } from './utils';


export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    {
        path: 'session-expired',
        loadChildren: () => import('./session-expired/session-expired.module').then(m => m.SessionExpiredModule),
        data: { type: 'redirect' },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    { path: 'status', component: StatusComponent },
    {
        path: 'health',
        loadChildren: () => import('./health/health.module').then(m => m.HealthModule)
    },
    {
        path: 'freight-forwader',
        redirectTo: 'freight-forwarder',
        pathMatch: 'prefix'
    },
    {
        path: 'freight-forwarder',
        loadChildren: () => import('./freight-forwader/freight-forwader.module').then(m => m.FreightForwaderModule),
        data: { expectedRoles: [ProfileConst.freightfwd_pf, ProfileConst.forwaderTrucker_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
        data: { expectedRoles: [ProfileConst.admin_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'anonymous-chat',
        loadChildren: () => import('./anonymous-chat/anonymous-chat.module').then(m => m.AnonymousChatModule)
    },
    {
        path: 'manual',
        loadChildren: () => import('./manual/manual.module').then(m => m.ManualModule),
        data: { expectedRoles: [ProfileConst.freightfwd_pf, ProfileConst.forwaderTrucker_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./dashboard-facility/dashboard-facility.module').then(m => m.DashboardFacilityModule),
        data: { expectedRoles: [ProfileConst.dashboard_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'gha',
        loadChildren: () => import('./gha/gha.module').then(m => m.GhaModule),
        data: { expectedRoles: [ProfileConst.gha_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'global-admin',
        loadChildren: () => import('./global-admin/global-admin.module').then(m => m.GlobalAdminModule),
        data: { expectedRoles: [ProfileConst.admin_global_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'warehouse-admin',
        loadChildren: () => import('./warehouse-admin/warehouse-admin.module').then(m => m.WarehouseAdminModule),
        data: { expectedRoles: [ProfileConst.admin_warehouse_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'airline',
        loadChildren: () => import('./airline/airline.module').then(m => m.AirlineModule),
        data: { expectedRoles: [ProfileConst.airline_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'war-room',
        loadChildren: () => import('./war-room/war-room.module').then(m => m.WarRoomModule),
        data: { expectedRoles: [ProfileConst.war_room_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'public-pre-check-rejection',
        loadChildren: () => import('./public-pre-check-rejection/public-pre-check-rejection.module').then(m => m.PublicPreCheckRejectionModule)
    },
    {
        path: 'airline-supervisor',
        loadChildren: () => import('./airline-supervisor/airline-supervisor.module').then(m => m.AirlineSupervisorModule),
        data: { expectedRoles: [ProfileConst.airline_supervisor_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'airline-admin',
        loadChildren: () => import('./airline-admin/airline-admin.module').then(m => m.AirlineAdminModule),
        data: { expectedRoles: [ProfileConst.airline_admin_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'airline-agent',
        loadChildren: () => import('./airline-agent/airline-agent.module').then(m => m.AirlineAgentModule),
        data: { expectedRoles: [ProfileConst.airline_agent_pf] },
        canActivate: [RoleGuard],
        runGuardsAndResolvers: 'always'
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
    exports: [RouterModule],
    providers: [
        RoleGuard
    ]
})
export class AppRoutingModule { }
